import React from 'react';
import Icon from '../../../components/AppIcon';

const contentTypes = [
  {
    id: 'daily-message',
    label: 'Günlük Mesaj',
    icon: 'MessageSquare',
    color: 'var(--color-primary)',
    description: 'Instagram Stories paylaşımı ile günlük mesaj'
  },
  {
    id: 'mini-task',
    label: 'Mini Görev',
    icon: 'CheckSquare',
    color: 'var(--color-success)',
    description: '"Yaptım" butonu ile tamamlanabilir görev'
  },
  {
    id: 'poll',
    label: 'Anket',
    icon: 'BarChart3',
    color: 'var(--color-accent)',
    description: '3-4 seçenekli anket ve canlı sonuçlar'
  },
  {
    id: 'humor',
    label: 'Eğlence',
    icon: 'Smile',
    color: 'var(--color-warning)',
    description: 'Emoji tepkileri ile eğlenceli içerik'
  },
  {
    id: 'giveaway',
    label: 'Çekiliş Günü',
    icon: 'Gift',
    color: 'var(--color-destructive)',
    description: 'Katılım butonu ile çekiliş'
  },
  {
    id: 'social-awareness',
    label: 'Sosyal Farkındalık',
    icon: 'Heart',
    color: 'var(--color-secondary)',
    description: '"Katılıyorum" butonu ile farkındalık mesajı'
  },
  {
    id: 'surprise',
    label: 'Sürpriz Günü',
    icon: 'Sparkles',
    color: 'var(--color-accent)',
    description: 'Özel tanımlı sürpriz içerik'
  }
];

const ContentTypeSelector = ({ selectedType, onTypeChange }) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Layout" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            İçerik Tipi Seçimi
          </h3>
          <p className="caption text-muted-foreground">
            Bugün için gösterilecek içerik tipini seçin
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {contentTypes?.map((type) => (
          <button
            key={type?.id}
            onClick={() => onTypeChange(type?.id)}
            className={`p-4 md:p-6 rounded-xl border-2 transition-all duration-250 text-left ${
              selectedType === type?.id
                ? 'border-primary bg-primary/5 shadow-md'
                : 'border-border hover:border-primary/50 bg-card'
            }`}
          >
            <div className="flex items-start gap-3 mb-3">
              <div
                className="w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${type?.color}15` }}
              >
                <Icon name={type?.icon} size={20} color={type?.color} />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-base md:text-lg font-heading font-semibold text-foreground mb-1">
                  {type?.label}
                </h4>
                <p className="caption text-muted-foreground line-clamp-2">
                  {type?.description}
                </p>
              </div>
            </div>
            {selectedType === type?.id && (
              <div className="flex items-center gap-2 text-primary caption font-medium">
                <Icon name="CheckCircle" size={16} />
                <span>Seçili</span>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ContentTypeSelector;